import { render, staticRenderFns } from "./WapHeader.vue?vue&type=template&id=6201ca9e&scoped=true&"
import script from "./WapHeader.vue?vue&type=script&lang=js&"
export * from "./WapHeader.vue?vue&type=script&lang=js&"
import style0 from "./WapHeader.vue?vue&type=style&index=0&id=6201ca9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201ca9e",
  null
  
)

export default component.exports